import type { TagColor } from '@/components/Tag/Tag'

import type { CurriculumStatus } from '../queries/useCurriculums'

export const curriculumStatusToTagColorMap: Record<CurriculumStatus, TagColor> =
  {
    draft: 'gray',
    active: 'green'
  }
